module.exports = __webpack_public_path__ + "img/box6-23.fa13c07c.png";